import { ActionCollect } from "../../models/Data";

export const billDataCollectReducer = (state: any[], action: ActionCollect): any[] => {
  switch (action.type) {
    case "UPDATE_FIELD": {
      const { index, fieldPath, value } = action.payload;
      const newState = JSON.parse(JSON.stringify(state));
      const parts = fieldPath.split(/\.|\[|\]/).filter(Boolean);
      let current = newState[index];
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];

        if (i === parts.length - 1) {
          current[part] = value;
        } else {
          if (!current[part]) {
            console.error(
              `Field path "${fieldPath}" is invalid at "${part}".`
            );
            return state;
          }
          current = current[part];
        }
      }
      return newState;
    }

    case "ADD_COLLECTION_ENTRY": {
      const { index } = action.payload;
      const newState = [...state];
      newState[index] = {
        ...newState[index],
        collect: [
          ...newState[index].collect,
          { id: 0, amount: 0, type: "CASH" },
        ],
      };
      return newState;
    }

    case "DELETE_COLLECTION_ENTRY": {
      const { invoiceIndex, collectIndex } = action.payload;
      const newState = [...state];
      newState[invoiceIndex] = {
        ...newState[invoiceIndex],
        collect: newState[invoiceIndex].collect.filter(
          (_: any, i: number) => i !== collectIndex
        ),
      };
      return newState;
    }

    default:
      return state;
  }
};

